import React, { Dispatch, SetStateAction, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

type MOStep3Props = {
	setCurrentStep: Dispatch<SetStateAction<number | string>>;
	membershipQuestions: any;
	setMembershipQuestions: Dispatch<any>;
};

export const MOStep3: React.FC<MOStep3Props> = ({
	setCurrentStep,
	membershipQuestions,
	setMembershipQuestions,
}) => {
	const [initialDetails, setInitialDetails] = useState<any>(membershipQuestions);	

	const validationSchema = Yup.object({
		selectedSubject: Yup.mixed().required('Please select a subject').nullable(),
	});	

	const handleSubmit = async (values: any) => {
		setMembershipQuestions(values);
		setCurrentStep(4);
	};

	return (
		<>
			<div className="MOSpeechBubbleQuestion">
				<div className="SpeechBubbleQ">
					<h1>Which subjects are you interested in?</h1>
				</div>
			</div>

			<Formik
				initialValues={initialDetails}
				onSubmit={handleSubmit}
				validateOnChange={false}
				validateOnBlur={false}
				validateOnMount={false}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(formik) => {
					let values: any = formik.values;

					return (
						<Form>
							<div className="MOQForm">
								{formik.errors.selectedSubject && <p className="ErrorTxt">{(formik as any).errors.selectedSubject}</p>}
								<div className="RadioBtnsList">
									{values.subjects.map((option: any, index: number) => {
										return (
											<div 
												key={option.name}
												className={"RBBlock" + (option.ids === values.selectedSubject ? " Checked" : "")}
												onClick={() => {
													formik.setFieldValue("selectedSubject", option.ids);
													formik.setFieldValue("selectedSubjectName", option.name);
												}}
											>
												<div className="Checkbox">
													<input id={"MO_Radio_" + index} type="radio" name={"MO_Radio_List"} checked={option.ids === values.selectedSubject} readOnly />
													<label className="CustomInput" htmlFor={"MO_Radio_" + index}>
														{option.name}
													</label>
												</div>
											</div>
										);
									})}									
								</div>

								<div className="Btn BtnOrange SubmitBtn" onClick={formik.submitForm}>Next question</div>
								<div className="Btn BtnWhite BackBtn" onClick={() => setCurrentStep(2)}>Back</div>
							</div>
						</Form>
					);
				}}
			</Formik>
		</>
	);
};